/**
 * Kalkulator BMI.
 *
 * Formularz, wynik z 6 klasami WHO i skala stoją w źródle HTML. Skrypt tylko
 * liczy i wypełnia elementy oznaczone atrybutem data-role. Przeliczanie na
 * żywo (przy zmianie pól) działa dopiero po pierwszym kliknięciu "Oblicz BMI" -
 * do tego czasu wpisywanie w pola niczego nie liczy i nie zmienia ostatniego
 * wyniku.
 *
 * Vanilla JS, bez jQuery.
 */
(function () {
	'use strict';

	var CONFIG = {
		calorieUrl: '/kalkulator-kalorii/',
		mobileBreakpoint: 992, // media-breakpoint-down(lg) w motywie
		headerOffset: 80 // wysokość przyklejonego nagłówka strony na mobile, w px
	};

	// 6 klas WHO w kolejności wyświetlania na skali.
	var CATS = [
		{ name: 'Niedowaga', short: 'niedowaga', range: '<18,5', color: '#4A90D9', text: '#FFFFFF', cta: 'Sprawdź, ile kalorii jeść, żeby przytyć' },
		{ name: 'Prawidłowa masa', short: 'norma', range: '18,5–24,9', color: '#2FA866', text: '#FFFFFF', cta: 'Sprawdź, ile kalorii jeść, żeby utrzymać wagę' },
		{ name: 'Nadwaga', short: 'nadwaga', range: '25–29,9', color: '#F2C230', text: '#3A2C00', cta: 'Sprawdź, ile kalorii jeść, żeby schudnąć' },
		{ name: 'Otyłość I stopnia', short: 'otyłość I', range: '30–34,9', color: '#F29A38', text: '#3A2000', cta: 'Sprawdź, ile kalorii jeść, żeby schudnąć' },
		{ name: 'Otyłość II stopnia', short: 'otyłość II', range: '35–39,9', color: '#E4632C', text: '#FFFFFF', cta: 'Sprawdź, ile kalorii jeść, żeby schudnąć' },
		{ name: 'Otyłość III stopnia', short: 'otyłość III', range: '40+', color: '#C43B32', text: '#FFFFFF', cta: 'Sprawdź, ile kalorii jeść, żeby schudnąć' }
	];

	// Granice segmentów skali; skrajne segmenty rysujemy od 15 i do 45.
	var BOUNDS = [15, 18.5, 25, 30, 35, 40, 45];

	var PATTERN_WEIGHT = /^(?:[1-9]|[1-9][0-9]|[1-2][0-9]{2}|300)(?:[.,]\d+)?$/;
	var PATTERN_HEIGHT = /^(?:[1-9]|[1-9][0-9]|1[0-9]{2}|2[0-1][0-9]|22[0-5])(?:[.,]\d+)?$/;

	function readValue(input, pattern) {
		var raw = input.value.trim();
		if (!pattern.test(raw)) {
			return null;
		}
		return parseFloat(raw.replace(',', '.'));
	}

	function categoryIndex(bmi) {
		if (bmi < 18.5) {
			return 0;
		}
		if (bmi < 25) {
			return 1;
		}
		if (bmi < 30) {
			return 2;
		}
		if (bmi < 35) {
			return 3;
		}
		if (bmi < 40) {
			return 4;
		}
		return 5;
	}

	/**
	 * Pozycja na skali 0-1: równe segmenty, proporcjonalnie wewnątrz segmentu,
	 * wartości poniżej 15 i powyżej 45 zatrzymują się na brzegach.
	 */
	function scalePosition(bmi) {
		var x = Math.max(BOUNDS[0], Math.min(BOUNDS[6], bmi));
		for (var i = 0; i < 6; i++) {
			if (x < BOUNDS[i + 1] || i === 5) {
				var f = (x - BOUNDS[i]) / (BOUNDS[i + 1] - BOUNDS[i]);
				return (i + Math.max(0, Math.min(1, f))) / 6;
			}
		}
		return 0;
	}

	function formatBmi(bmi) {
		return (Math.round(bmi * 10) / 10).toFixed(1).replace('.', ',');
	}

	function isMobile() {
		return window.innerWidth < CONFIG.mobileBreakpoint;
	}

	function initCalculator(root) {
		var form = root.querySelector('[data-role="form"]');
		var weightIn = root.querySelector('[data-role="weight-input"]');
		var heightIn = root.querySelector('[data-role="height-input"]');
		var weightField = root.querySelector('[data-field="weight"]');
		var heightField = root.querySelector('[data-field="height"]');
		var submitBtn = root.querySelector('[data-role="submit"]');
		var hint = root.querySelector('[data-role="hint"]');
		var result = root.querySelector('[data-role="result"]');
		var bubble = root.querySelector('[data-role="bubble"]');
		var arrow = root.querySelector('[data-role="arrow"]');
		var segs = root.querySelector('[data-role="segs"]');
		var numEl = root.querySelector('[data-role="num"]');
		var chipEl = root.querySelector('[data-role="chip"]');
		var labelsDesktop = root.querySelector('[data-role="labels-desktop"]');
		var labelsMobile = root.querySelector('[data-role="labels-mobile"]');
		var heightOut = root.querySelector('[data-role="height-out"]');
		var rangeEl = root.querySelector('[data-role="range"]');
		var ctaEl = root.querySelector('[data-role="cta"]');
		var ctaTextEl = root.querySelector('[data-role="cta-text"]');

		if (!form || !weightIn || !heightIn || !result) {
			return;
		}

		var calculated = false; // czy było już pierwsze obliczenie
		var last = null; // ostatnie poprawne dane { weight, height, bmi }

		function placeMarker() {
			if (!last || result.hidden) {
				return;
			}
			var width = segs.clientWidth;
			var center = scalePosition(last.bmi) * width;
			var bw = bubble.offsetWidth;
			var bubbleRadius = 8; // border-radius dymka w scss (rem(8))
			var arrowHalf = 8; // połowa podstawy grota (border-left/right w scss)

			// Dymek nie wyjeżdża poza kartę.
			var bubbleLeft = Math.max(0, Math.min(width - bw, center - bw / 2));
			bubble.style.left = bubbleLeft + 'px';

			/*
			 * Strzałka trzyma się środka dymka, ale przy skrajnych wynikach
			 * (niedowaga, otyłość III), gdy dymek jest przyklejony do brzegu
			 * skali, grot musi zostać w prostej części tła, a nie dokładnie
			 * na zaokrąglonym rogu - inaczej krawędź grota pokrywa się z
			 * krawędzią zaokrąglenia dymka.
			 */
			var arrowMin = bubbleLeft + bubbleRadius + arrowHalf;
			var arrowMax = bubbleLeft + bw - bubbleRadius - arrowHalf;
			arrow.style.left = Math.max(arrowMin, Math.min(arrowMax, center)) + 'px';
		}

		function render(weight, height) {
			var m = height / 100;
			var bmi = weight / (m * m);
			var idx = categoryIndex(bmi);
			var cat = CATS[idx];
			last = { weight: weight, height: height, bmi: bmi };

			numEl.textContent = formatBmi(bmi);

			chipEl.textContent = cat.name;
			chipEl.style.background = cat.color;
			chipEl.style.color = cat.text;

			bubble.textContent = isMobile() ? 'Tu jesteś' : 'Tu jesteś · ' + formatBmi(bmi);
			bubble.style.background = cat.color;
			bubble.style.color = cat.text;
			arrow.style.borderTopColor = cat.color;

			segs.innerHTML = CATS.map(function (c, i) {
				var active = i === idx;
				var ring = active ? ';box-shadow:0 0 0 2px var(--bmi-color-white, #fff),0 0 0 3.5px ' + c.color : '';
				return '<span class="bmi-calculator__seg' + (active ? ' is-active' : '') + '" style="background:' + c.color + ring + '"></span>';
			}).join('');

			labelsDesktop.innerHTML = CATS.map(function (c, i) {
				return '<span' + (i === idx ? ' class="is-active"' : '') + '>' + c.short + '<br>' + c.range + '</span>';
			}).join('');

			labelsMobile.innerHTML =
				'<span>niedowaga</span>' +
				'<span class="is-active">' + cat.short + ' ' + cat.range + '</span>' +
				'<span>otyłość</span>';

			heightOut.textContent = Math.round(height);
			rangeEl.textContent = Math.ceil(18.5 * m * m) + '–' + Math.floor(24.9 * m * m) + ' kg';

			ctaTextEl.textContent = cat.cta;
			ctaEl.href = CONFIG.calorieUrl;

			result.hidden = false;
			window.requestAnimationFrame(placeMarker);
		}

		// Tylko przy pierwszym obliczeniu.
		function scrollToResult() {
			window.requestAnimationFrame(function () {
				if (isMobile()) {
					var top = result.getBoundingClientRect().top + window.pageYOffset - CONFIG.headerOffset;
					window.scrollTo({ top: top, behavior: 'smooth' });
				} else {
					result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				}
			});
		}

		function setError(field, on) {
			field.classList.toggle('has-error', on);
			field.querySelector('.bmi-calculator__error').hidden = !on;
		}

		// Dozwolone tylko cyfry, kropka i przecinek.
		[weightIn, heightIn].forEach(function (input) {
			input.addEventListener('input', function () {
				input.value = input.value.replace(/[^0-9.,]/g, '');
				setError(input === weightIn ? weightField : heightField, false);

				// Przeliczanie na żywo dopiero po pierwszym obliczeniu; niepełne
				// lub błędne dane nie zmieniają ostatniego wyniku.
				if (!calculated) {
					return;
				}
				var w = readValue(weightIn, PATTERN_WEIGHT);
				var h = readValue(heightIn, PATTERN_HEIGHT);
				if (w !== null && h !== null) {
					render(w, h);
				}
			});
		});

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			var w = readValue(weightIn, PATTERN_WEIGHT);
			var h = readValue(heightIn, PATTERN_HEIGHT);
			setError(weightField, w === null);
			setError(heightField, h === null);
			if (w === null) {
				weightIn.focus();
				return;
			}
			if (h === null) {
				heightIn.focus();
				return;
			}

			render(w, h);

			if (!calculated) {
				calculated = true;
				submitBtn.hidden = true; // po pierwszym wyniku przycisk znika
				hint.hidden = false; // w jego miejscu informacja o przeliczaniu na żywo
				scrollToResult();
			}
		});

		window.addEventListener('resize', function () {
			if (last) {
				render(last.weight, last.height);
			}
		});
	}

	function init() {
		var blocks = Array.prototype.slice.call(document.querySelectorAll('.bmi-calculator'));
		blocks.forEach(initCalculator);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
